// extracted by mini-css-extract-plugin
export default {"generate_table_container_container":"generate-table-container_generate_table_container_container__G9T6b"};